// Lightweight i18n: English / Hindi / Punjabi
// All user-facing UI labels live here. Body paragraphs stay in English to keep
// the file small — we can extend later if needed.
import { createContext, useContext, useEffect, useState } from 'react';

const translations = {
  en: {
    // Top bars
    iso_certified: 'ISO 9001 Certified Company',
    manufacturing_since: 'Manufacturing Industrial Furnaces Since 1960',
    factory_label: 'Factory: Amritsar and Ludhiana, India',
    // Nav
    nav_home: 'Home',
    nav_products: 'Products',
    nav_services: 'Services',
    nav_about: 'About',
    nav_contact: 'Contact',
    request_quote: 'Request Quote',
    // Hero
    hero_badge: 'ISO 9001 CERTIFIED · INDUSTRIAL FURNACE MANUFACTURERS',
    hero_title_a: 'Built to Heat —',
    hero_title_b: 'Built to Perform',
    hero_subtitle:
      "Six decades of designing, manufacturing and commissioning custom-engineered industrial furnaces and turnkey heat-treatment lines for India's most demanding manufacturers — built for durability, precision and production-scale repeatability.",
    explore_products: 'Explore Products',
    stat_founded: 'Founded',
    stat_installations: 'Installations',
    stat_clients: 'Clients',
    // Featured
    featured_products: 'Featured Products',
    view_details: 'View Details',
    view_all_products: 'View All Products',
    // Why
    why_choose: 'Why Choose',
    why_subtitle:
      'Superior product quality, ethical practices, and precise engineering — trusted by industry leaders across India.',
    // CTA
    cta_title: "Let's build heat together",
    cta_subtitle:
      "Tell us your capacity and target throughput — we'll deliver a concept within 48 hours.",
    download_catalog: 'Download Catalog',
    // Footer
    footer_quick_links: 'Quick Links',
    footer_product_range: 'Product Range',
    footer_get_in_touch: 'Get In Touch',
    footer_factories: 'Factories',
    factories_value: 'Amritsar & Ludhiana',
    footer_address_title: 'Registered Address',
    footer_designed_by: 'Designed by Arkotherm · ISO 9001 Certified Manufacturer',
    // Products page
    our_products: 'Our Products · ISO 9001 Certified',
    products_title_a: 'Industrial Furnaces',
    products_title_b: 'Heat Treatment Solutions',
    products_subtitle:
      'Explore our comprehensive range of industrial furnaces and heat treatment equipment — designed, manufactured and commissioned in-house at our Amritsar and Ludhiana facilities.',
    filter_all: 'All Products',
    filter_annealing: 'Annealing Furnace',
    filter_continuous: 'Continuous Mesh Belt Furnace',
    filter_retort: 'Retort',
    filter_spares: 'Spare Parts',
    filter_carburizing: 'Gas Carburizing Furnace',
    view_specs: 'View Specifications',
    need_custom: 'Need a Custom Solution?',
    custom_subtitle:
      "Tell us your requirements and we'll design a solution tailored to your needs.",
    // Contact
    contact_badge: 'Contact Us · ISO 9001 Certified Company',
    contact_title_a: "Let's Build Something",
    contact_title_b: 'Great Together',
    contact_subtitle:
      'Ready to discuss your heat treatment needs? Fill out the form below and our team will respond within 24 hours.',
    phone_label: 'Phone',
    email_label: 'Email',
    address_label: 'Registered Address',
    factories_label: 'Factories',
    // Floating
    whatsapp_chat: 'Chat on WhatsApp',
    // Language switcher
    lang_label: 'Language',
  },
  hi: {
    iso_certified: 'आईएसओ 9001 प्रमाणित कंपनी',
    manufacturing_since: '1960 से औद्योगिक भट्ठियों का निर्माण',
    factory_label: 'फैक्ट्री: अमृतसर और लुधियाना, भारत',
    nav_home: 'मुख्य पृष्ठ',
    nav_products: 'उत्पाद',
    nav_services: 'सेवाएँ',
    nav_about: 'हमारे बारे में',
    nav_contact: 'संपर्क',
    request_quote: 'कोटेशन माँगें',
    hero_badge: 'आईएसओ 9001 प्रमाणित · औद्योगिक भट्ठी निर्माता',
    hero_title_a: 'गर्मी देने के लिए बने —',
    hero_title_b: 'प्रदर्शन के लिए बने',
    hero_subtitle:
      'छह दशकों से भारत के सबसे माँग वाले निर्माताओं के लिए कस्टम-इंजीनियर्ड औद्योगिक भट्ठियाँ और टर्नकी हीट-ट्रीटमेंट लाइनें डिज़ाइन, निर्माण और कमीशन कर रहे हैं — टिकाऊपन, परिशुद्धता और उत्पादन-स्तर की पुनरावृत्ति के लिए।',
    explore_products: 'उत्पाद देखें',
    stat_founded: 'स्थापना',
    stat_installations: 'इंस्टॉलेशन',
    stat_clients: 'ग्राहक',
    featured_products: 'चयनित उत्पाद',
    view_details: 'विवरण देखें',
    view_all_products: 'सभी उत्पाद देखें',
    why_choose: 'क्यों चुनें',
    why_subtitle:
      'बेहतर उत्पाद गुणवत्ता, नैतिक प्रथाएँ और सटीक इंजीनियरिंग — भारत भर के उद्योग जगत द्वारा भरोसेमंद।',
    cta_title: 'आइए मिलकर गर्मी बनाएँ',
    cta_subtitle:
      'अपनी क्षमता और लक्ष्य थ्रूपुट बताएँ — हम 48 घंटों के भीतर एक कांसेप्ट प्रस्तुत करेंगे।',
    download_catalog: 'कैटलॉग डाउनलोड करें',
    footer_quick_links: 'त्वरित लिंक',
    footer_product_range: 'उत्पाद श्रेणी',
    footer_get_in_touch: 'संपर्क करें',
    footer_factories: 'फैक्ट्रियाँ',
    factories_value: 'अमृतसर और लुधियाना',
    footer_address_title: 'पंजीकृत पता',
    footer_designed_by: 'डिज़ाइन: Arkotherm · ISO 9001 प्रमाणित निर्माता',
    our_products: 'हमारे उत्पाद · आईएसओ 9001 प्रमाणित',
    products_title_a: 'औद्योगिक भट्ठियाँ',
    products_title_b: 'हीट ट्रीटमेंट समाधान',
    products_subtitle:
      'हमारे अमृतसर और लुधियाना संयंत्रों में डिज़ाइन, निर्मित और कमीशन की गई औद्योगिक भट्ठियों और हीट-ट्रीटमेंट उपकरणों की व्यापक श्रृंखला देखें।',
    filter_all: 'सभी उत्पाद',
    filter_annealing: 'एनीलिंग भट्ठी',
    filter_continuous: 'कन्टीन्युअस मेश बेल्ट भट्ठी',
    filter_retort: 'रिटॉर्ट',
    filter_spares: 'स्पेयर पार्ट्स',
    filter_carburizing: 'गैस कार्बराइज़िंग भट्ठी',
    view_specs: 'विशेषताएँ देखें',
    need_custom: 'कस्टम समाधान चाहिए?',
    custom_subtitle:
      'अपनी आवश्यकताएँ बताएँ और हम आपके लिए एक अनुकूलित समाधान डिज़ाइन करेंगे।',
    contact_badge: 'संपर्क करें · आईएसओ 9001 प्रमाणित कंपनी',
    contact_title_a: 'आइए कुछ बेहतरीन',
    contact_title_b: 'मिलकर बनाएँ',
    contact_subtitle:
      'अपनी हीट-ट्रीटमेंट ज़रूरतों पर चर्चा के लिए तैयार हैं? नीचे फ़ॉर्म भरें — हमारी टीम 24 घंटे में जवाब देगी।',
    phone_label: 'फ़ोन',
    email_label: 'ईमेल',
    address_label: 'पंजीकृत पता',
    factories_label: 'फैक्ट्रियाँ',
    whatsapp_chat: 'व्हाट्सऐप पर चैट करें',
    lang_label: 'भाषा',
  },
  pa: {
    iso_certified: 'ਆਈਐਸਓ 9001 ਪ੍ਰਮਾਣਿਤ ਕੰਪਨੀ',
    manufacturing_since: '1960 ਤੋਂ ਉਦਯੋਗਿਕ ਭੱਠੀਆਂ ਦਾ ਨਿਰਮਾਣ',
    factory_label: 'ਫੈਕਟਰੀ: ਅੰਮ੍ਰਿਤਸਰ ਅਤੇ ਲੁਧਿਆਣਾ, ਭਾਰਤ',
    nav_home: 'ਮੁੱਖ ਪੰਨਾ',
    nav_products: 'ਉਤਪਾਦ',
    nav_services: 'ਸੇਵਾਵਾਂ',
    nav_about: 'ਸਾਡੇ ਬਾਰੇ',
    nav_contact: 'ਸੰਪਰਕ',
    request_quote: 'ਕੋਟੇਸ਼ਨ ਮੰਗੋ',
    hero_badge: 'ਆਈਐਸਓ 9001 ਪ੍ਰਮਾਣਿਤ · ਉਦਯੋਗਿਕ ਭੱਠੀ ਨਿਰਮਾਤਾ',
    hero_title_a: 'ਗਰਮ ਕਰਨ ਲਈ ਬਣੇ —',
    hero_title_b: 'ਪ੍ਰਦਰਸ਼ਨ ਲਈ ਬਣੇ',
    hero_subtitle:
      'ਛੇ ਦਹਾਕਿਆਂ ਤੋਂ ਭਾਰਤ ਦੇ ਸਭ ਤੋਂ ਮੰਗ-ਦਾਰ ਨਿਰਮਾਤਾਵਾਂ ਲਈ ਕਸਟਮ-ਇੰਜੀਨੀਅਰ ਉਦਯੋਗਿਕ ਭੱਠੀਆਂ ਅਤੇ ਟਰਨ-ਕੀ ਹੀਟ-ਟਰੀਟਮੈਂਟ ਲਾਈਨਾਂ ਡਿਜ਼ਾਈਨ ਅਤੇ ਚਾਲੂ ਕਰ ਰਹੇ ਹਾਂ — ਟਿਕਾਊਤਾ, ਸ਼ੁੱਧਤਾ ਅਤੇ ਉਤਪਾਦਨ-ਪੱਧਰ ਦੀ ਦੁਹਰਾਈ ਲਈ।',
    explore_products: 'ਉਤਪਾਦ ਵੇਖੋ',
    stat_founded: 'ਸਥਾਪਨਾ',
    stat_installations: 'ਇੰਸਟਾਲੇਸ਼ਨ',
    stat_clients: 'ਗਾਹਕ',
    featured_products: 'ਚੁਣੇ ਉਤਪਾਦ',
    view_details: 'ਵੇਰਵਾ ਵੇਖੋ',
    view_all_products: 'ਸਾਰੇ ਉਤਪਾਦ ਵੇਖੋ',
    why_choose: 'ਕਿਉਂ ਚੁਣੋ',
    why_subtitle:
      'ਉੱਤਮ ਉਤਪਾਦ ਗੁਣਵੱਤਾ, ਨੈਤਿਕ ਅਭਿਆਸ ਅਤੇ ਸਟੀਕ ਇੰਜੀਨੀਅਰਿੰਗ — ਭਾਰਤ ਭਰ ਦੇ ਉਦਯੋਗ ਮੋਹਰੀਆਂ ਦਾ ਭਰੋਸਾ।',
    cta_title: "ਆਓ ਮਿਲ ਕੇ ਗਰਮੀ ਬਣਾਈਏ",
    cta_subtitle:
      "ਆਪਣੀ ਸਮਰੱਥਾ ਅਤੇ ਟਾਰਗੇਟ ਥਰੂਪੁਟ ਦੱਸੋ — ਅਸੀਂ 48 ਘੰਟਿਆਂ ਅੰਦਰ ਇੱਕ ਕਾਂਸੈਪਟ ਦੇਵਾਂਗੇ।",
    download_catalog: 'ਕੈਟਾਲਾਗ ਡਾਊਨਲੋਡ ਕਰੋ',
    footer_quick_links: 'ਤੇਜ਼ ਲਿੰਕ',
    footer_product_range: 'ਉਤਪਾਦ ਸ਼੍ਰੇਣੀ',
    footer_get_in_touch: 'ਸੰਪਰਕ ਕਰੋ',
    footer_factories: 'ਫੈਕਟਰੀਆਂ',
    factories_value: 'ਅੰਮ੍ਰਿਤਸਰ ਅਤੇ ਲੁਧਿਆਣਾ',
    footer_address_title: 'ਰਜਿਸਟਰਡ ਪਤਾ',
    footer_designed_by: 'ਡਿਜ਼ਾਈਨ: Arkotherm · ISO 9001 ਪ੍ਰਮਾਣਿਤ ਨਿਰਮਾਤਾ',
    our_products: 'ਸਾਡੇ ਉਤਪਾਦ · ਆਈਐਸਓ 9001 ਪ੍ਰਮਾਣਿਤ',
    products_title_a: 'ਉਦਯੋਗਿਕ ਭੱਠੀਆਂ',
    products_title_b: 'ਹੀਟ ਟਰੀਟਮੈਂਟ ਹੱਲ',
    products_subtitle:
      'ਅੰਮ੍ਰਿਤਸਰ ਅਤੇ ਲੁਧਿਆਣਾ ਪਲਾਂਟਾਂ ਵਿੱਚ ਡਿਜ਼ਾਈਨ, ਨਿਰਮਿਤ ਅਤੇ ਚਾਲੂ ਕੀਤੀਆਂ ਉਦਯੋਗਿਕ ਭੱਠੀਆਂ ਦੀ ਪੂਰੀ ਰੇਂਜ ਵੇਖੋ।',
    filter_all: 'ਸਾਰੇ ਉਤਪਾਦ',
    filter_annealing: 'ਐਨੀਲਿੰਗ ਭੱਠੀ',
    filter_continuous: 'ਕਨਟੀਨਿਊਅਸ ਮੈਸ਼ ਬੈਲਟ ਭੱਠੀ',
    filter_retort: 'ਰਿਟੌਰਟ',
    filter_spares: 'ਸਪੇਅਰ ਪਾਰਟਸ',
    filter_carburizing: 'ਗੈਸ ਕਾਰਬੁਰਾਈਜ਼ਿੰਗ ਭੱਠੀ',
    view_specs: 'ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਵੇਖੋ',
    need_custom: 'ਕਸਟਮ ਹੱਲ ਚਾਹੀਦਾ ਹੈ?',
    custom_subtitle:
      'ਆਪਣੀਆਂ ਲੋੜਾਂ ਦੱਸੋ ਅਤੇ ਅਸੀਂ ਤੁਹਾਡੇ ਲਈ ਖਾਸ ਡਿਜ਼ਾਈਨ ਕੀਤਾ ਹੱਲ ਬਣਾਵਾਂਗੇ।',
    contact_badge: 'ਸੰਪਰਕ ਕਰੋ · ਆਈਐਸਓ 9001 ਪ੍ਰਮਾਣਿਤ ਕੰਪਨੀ',
    contact_title_a: 'ਆਓ ਕੁਝ ਵਧੀਆ',
    contact_title_b: 'ਮਿਲ ਕੇ ਬਣਾਈਏ',
    contact_subtitle:
      'ਆਪਣੀਆਂ ਹੀਟ-ਟਰੀਟਮੈਂਟ ਲੋੜਾਂ ਬਾਰੇ ਚਰਚਾ ਲਈ ਤਿਆਰ ਹੋ? ਫਾਰਮ ਭਰੋ — ਸਾਡੀ ਟੀਮ 24 ਘੰਟਿਆਂ ਅੰਦਰ ਜਵਾਬ ਦੇਵੇਗੀ।',
    phone_label: 'ਫ਼ੋਨ',
    email_label: 'ਈ-ਮੇਲ',
    address_label: 'ਰਜਿਸਟਰਡ ਪਤਾ',
    factories_label: 'ਫੈਕਟਰੀਆਂ',
    whatsapp_chat: 'ਵਟਸਐਪ ਉੱਤੇ ਚੈਟ ਕਰੋ',
    lang_label: 'ਭਾਸ਼ਾ',
  },
};

const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(
    typeof window !== 'undefined' ? localStorage.getItem('arkotherm-lang') || 'en' : 'en'
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('arkotherm-lang', lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

export const LANGS = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'hi', label: 'हि', name: 'हिन्दी' },
  { code: 'pa', label: 'ਪੰ', name: 'ਪੰਜਾਬੀ' },
];
